/**
 * @fileoverview gRPC-Web generated client stub for csvexporter.private.subscriptions
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as subscriptions_pb from './subscriptions_pb';


export class SubscriptionsExporterServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorExportSubscriptions = new grpcWeb.MethodDescriptor(
    '/csvexporter.private.subscriptions.SubscriptionsExporterService/ExportSubscriptions',
    grpcWeb.MethodType.UNARY,
    subscriptions_pb.ExportSubscriptionsRequest,
    subscriptions_pb.ExportResponse,
    (request: subscriptions_pb.ExportSubscriptionsRequest) => {
      return request.serializeBinary();
    },
    subscriptions_pb.ExportResponse.deserializeBinary
  );

  exportSubscriptions(
    request: subscriptions_pb.ExportSubscriptionsRequest,
    metadata: grpcWeb.Metadata | null): Promise<subscriptions_pb.ExportResponse>;

  exportSubscriptions(
    request: subscriptions_pb.ExportSubscriptionsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: subscriptions_pb.ExportResponse) => void): grpcWeb.ClientReadableStream<subscriptions_pb.ExportResponse>;

  exportSubscriptions(
    request: subscriptions_pb.ExportSubscriptionsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: subscriptions_pb.ExportResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/csvexporter.private.subscriptions.SubscriptionsExporterService/ExportSubscriptions',
        request,
        metadata || {},
        this.methodDescriptorExportSubscriptions,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/csvexporter.private.subscriptions.SubscriptionsExporterService/ExportSubscriptions',
    request,
    metadata || {},
    this.methodDescriptorExportSubscriptions);
  }

}

